import { ButtonProps, SxProps } from "@mui/material";

import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import { Popover, Heading, Title } from "./styles";

export interface BenchmarkOverlayProps {
  children: React.ReactNode;
  renderControl: (controlProps: Partial<ButtonProps>) => React.ReactElement;
  sx?: SxProps;
  title: string;
}

const BenchmarkOverlay = ({
  children,
  renderControl,
  title,
  sx,
}: BenchmarkOverlayProps) => {
  const { open, anchorElement, onClick, onClose } = useAnchorElement();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onClose();
  };

  const handleControlClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onClick(event);
  };

  return (
    <>
      {renderControl({ onClick: handleControlClick })}
      <Popover
        open={open}
        anchorEl={anchorElement}
        onClick={handleClick}
        onClose={handleClose}
        sx={sx}
      >
        <Heading variant="apart">
          <Title variant="bodyPrimaryMed">{title}</Title>
        </Heading>
        {children}
      </Popover>
    </>
  );
};

export default BenchmarkOverlay;
